import { Avatar, AvatarProps } from 'antd';

export type AppAvatarProps = AvatarProps & {
    accessibilityLabel?: string;
};

export const AppAvatar = ({ accessibilityLabel, ...props }: AppAvatarProps) => (
    <Avatar aria-label={accessibilityLabel} {...props} />
);
